import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';
import { fromError } from '../reducers';
import { Error } from '../models';

export const getErrorRootState: MemoizedSelector<object, fromError.State> = createFeatureSelector<
  fromError.State
>('error');
export const getErrorState: MemoizedSelector<object, fromError.State> = createSelector(
  getErrorRootState,
  state => state
);

const errorSelectors = fromError.errorAdapter.getSelectors(getErrorState);
export const getAllErrors: (state: object) => Error[] = errorSelectors.selectAll;
export const getErrorEntities: (state: object) => Dictionary<Error> = errorSelectors.selectEntities;

/**
 * Selector to return the number of current errors
 */
export const getErrorCount: MemoizedSelector<object, number> = createSelector(
  getAllErrors,
  errors => errors.length
);

/**
 * Selector to return if there are any errors
 */
export const getHasError: MemoizedSelector<object, boolean> = createSelector(
  getErrorCount,
  errorCount => errorCount !== 0
);
